import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { FetchAppLoginParams } from './type';

export const fetchAppLogin = async (appLoginParams: FetchAppLoginParams) => {
  const res = await fetchExtended('/v1/member/app_login', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(appLoginParams),
  });

  const result = await res.json();

  return result as any;
};
